import { jsx, jsxs } from "react/jsx-runtime";
import { preventDefault, useContainer } from "@tldraw/editor";
import classNames from "classnames";
import { DropdownMenu as _DropdownMenu } from "radix-ui";
import { useMenuIsOpen } from "../../hooks/useMenuIsOpen.mjs";
import { useDirection, useTranslation } from "../../hooks/useTranslation/useTranslation.mjs";
import { TldrawUiButton } from "./Button/TldrawUiButton.mjs";
import { TldrawUiButtonIcon } from "./Button/TldrawUiButtonIcon.mjs";
import { TldrawUiButtonLabel } from "./Button/TldrawUiButtonLabel.mjs";
import { TldrawUiIcon } from "./TldrawUiIcon.mjs";
function TldrawUiDropdownMenuRoot({
  id,
  children,
  modal = false,
  debugOpen = false
}) {
  const [open, onOpenChange] = useMenuIsOpen(id);
  const dir = useDirection();
  return /* @__PURE__ */ jsx(
    _DropdownMenu.Root,
    {
      open: debugOpen || open,
      dir,
      modal,
      onOpenChange,
      children
    }
  );
}
function TldrawUiDropdownMenuTrigger({ children, ...rest }) {
  const dir = useDirection();
  return /* @__PURE__ */ jsx(
    _DropdownMenu.Trigger,
    {
      dir,
      asChild: true,
      onTouchEnd: (e) => preventDefault(e),
      ...rest,
      children
    }
  );
}
function TldrawUiDropdownMenuContent({
  className,
  side = "bottom",
  align = "start",
  sideOffset = 8,
  alignOffset = 8,
  collisionPadding = 4,
  children
}) {
  const container = useContainer();
  return /* @__PURE__ */ jsx(_DropdownMenu.Portal, { container, children: /* @__PURE__ */ jsx(
    _DropdownMenu.Content,
    {
      className: classNames("tlui-menu", className),
      side,
      sideOffset,
      align,
      alignOffset,
      collisionPadding,
      children
    }
  ) });
}
function TldrawUiDropdownMenuSub({ id, children }) {
  const [open, onOpenChange] = useMenuIsOpen(id);
  return /* @__PURE__ */ jsx(_DropdownMenu.Sub, { open, onOpenChange, children });
}
function TldrawUiDropdownMenuSubTrigger({
  id,
  label,
  title,
  disabled
}) {
  const dir = useDirection();
  return /* @__PURE__ */ jsx(_DropdownMenu.SubTrigger, { dir, asChild: true, disabled, children: /* @__PURE__ */ jsxs(
    TldrawUiButton,
    {
      "data-testid": id,
      type: "menu",
      className: "tlui-menu__submenu__trigger",
      disabled,
      title,
      children: [
        /* @__PURE__ */ jsx(TldrawUiButtonLabel, { children: label }),
        /* @__PURE__ */ jsx(TldrawUiButtonIcon, { icon: dir === "rtl" ? "chevron-left" : "chevron-right", small: true })
      ]
    }
  ) });
}
function TldrawUiDropdownMenuSubContent({
  id,
  alignOffset = -1,
  sideOffset = -6,
  size = "small",
  children
}) {
  const container = useContainer();
  return /* @__PURE__ */ jsx(_DropdownMenu.Portal, { container, children: /* @__PURE__ */ jsx(
    _DropdownMenu.SubContent,
    {
      "data-testid": id,
      className: "tlui-menu tlui-menu__submenu__content",
      alignOffset,
      sideOffset,
      collisionPadding: 4,
      "data-size": size,
      children
    }
  ) });
}
function TldrawUiDropdownMenuGroup({ className, children }) {
  const dir = useDirection();
  return /* @__PURE__ */ jsx("div", { dir, className: classNames("tlui-menu__group", className), children });
}
function TldrawUiDropdownMenuIndicator() {
  const msg = useTranslation();
  const dir = useDirection();
  return /* @__PURE__ */ jsx(_DropdownMenu.ItemIndicator, { dir, asChild: true, children: /* @__PURE__ */ jsx(TldrawUiIcon, { label: msg("ui.checked"), icon: "check" }) });
}
function TldrawUiDropdownMenuItem({ noClose, children }) {
  const dir = useDirection();
  return /* @__PURE__ */ jsx(_DropdownMenu.Item, { dir, asChild: true, onClick: noClose ? preventDefault : void 0, children });
}
function TldrawUiDropdownMenuCheckboxItem({
  children,
  onSelect,
  ...rest
}) {
  const msg = useTranslation();
  const dir = useDirection();
  return /* @__PURE__ */ jsxs(
    _DropdownMenu.CheckboxItem,
    {
      dir,
      className: "tlui-button tlui-button__menu tlui-button__checkbox",
      onSelect: (e) => {
        onSelect?.(e);
        preventDefault(e);
      },
      ...rest,
      children: [
        /* @__PURE__ */ jsx("div", { className: "tlui-button__checkbox__indicator", children: /* @__PURE__ */ jsx(_DropdownMenu.ItemIndicator, { dir, children: /* @__PURE__ */ jsx(TldrawUiIcon, { label: msg("ui.checked"), icon: "check", small: true }) }) }),
        children
      ]
    }
  );
}
export {
  TldrawUiDropdownMenuCheckboxItem,
  TldrawUiDropdownMenuContent,
  TldrawUiDropdownMenuGroup,
  TldrawUiDropdownMenuIndicator,
  TldrawUiDropdownMenuItem,
  TldrawUiDropdownMenuRoot,
  TldrawUiDropdownMenuSub,
  TldrawUiDropdownMenuSubContent,
  TldrawUiDropdownMenuSubTrigger,
  TldrawUiDropdownMenuTrigger
};
//# sourceMappingURL=TldrawUiDropdownMenu.mjs.map
